import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function InfoCard(props){
    return(
        <div className={`block ${props.sizeClass} p-3 border border-advise-color rounded-lg shadow-l`} 
            style={{...props.style, padding: "15px"}}>
            <div className="card-header">
                <div className="icon-title">
                    <p className="font-semibold text-advise-color" 
                        style={{fontSize: "1.7rem", width: "90%"}}>
                        {props.title}
                    </p>
                </div>       
                <div className="icon-container">
                    <FontAwesomeIcon icon={props.icon} className='fa-3x text-advise-color' 
                    style={{position: "absolute", top: 0, right: 0, margin: 1}}/>
                </div>             
            </div>
            <div className="card-body">
                {props.body}
            </div>
        </div>
    )
}